function isInWindmillByMY() {
  var isMiniApp = typeof my === 'object';
  if (!isMiniApp) return false;

  try {
    var UA = '';

    try {
      UA = navigator ? navigator.userAgent || navigator.swuserAgent : '';
    } catch (e) {}

    if (!UA) {
      try {
        UA = clientInformation ? clientInformation.appVersion : '';
      } catch (e) {}
    }

    var isDD = false;

    try {
      isDD = !!dd;
    } catch (e) {}

    return isDD || /AliApp\(AP/.test(UA) || /AliApp\(DingTalk/.test(UA) || /micromessenger/.test(UA);
  } catch (e) {
    return false;
  }
}

export { isInWindmillByMY };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-api@1.1.12@@ali/aes-tracker-plugin-api/es/utils/util.js
// module id = null
// module chunks = 